// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  versonaId: __t.u64(),
  name: __t.string(),
  archetype: __t.string(),
  persona: __t.string(),
  context: __t.string(),
  greeting: __t.string(),
  deflect: __t.string(),
  topicsJson: __t.string(),
  llm: __t.bool(),
  strict: __t.bool(),
  temperature: __t.f32(),
  maxWords: __t.u32(),
  wanderM: __t.f32(),
};
